/**
 * Organization message limits, enforced by the backend DTOs and mirrored by
 * the internal tool's composer so both sides refuse the same input.
 */
export const MAX_TITLE_LENGTH = 200;
export const MAX_BODY_LENGTH = 2000;
export const MAX_LINK_LABEL_LENGTH = 40;
export const MAX_LINK_TARGET_LENGTH = 2000;
export const MAX_AUDIENCE_COMPANIES = 500;
